/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hotel_Nav_PricingInputs */

const en_hotel_nav_pricing = /** @type {(inputs: Hotel_Nav_PricingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricing`)
};

/**
* | output |
* | --- |
* | "Pricing" |
*
* @param {Hotel_Nav_PricingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const hotel_nav_pricing = /** @type {((inputs?: Hotel_Nav_PricingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hotel_Nav_PricingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_hotel_nav_pricing(inputs)
});
export { hotel_nav_pricing as "hotel.nav.pricing" }